import React from 'react';
import { OutlineOnHoverRoundedDangerLarge, type OutlineOnHoverRoundedDangerLargeProps } from './Variants/OutlineOnHoverRoundedDangerLarge/OutlineOnHoverRoundedDangerLarge';
import { RoundedBlue, type RoundedBlueProps } from './Variants/RoundedBlue/RoundedBlue';
import { RoundedDark, type RoundedDarkProps } from './Variants/RoundedDark/RoundedDark';
import { RoundedGrayLarge, type RoundedGrayLargeProps } from './Variants/RoundedGrayLarge/RoundedGrayLarge';

export const ButtonVariants = {
  OUTLINE_ON_HOVER_ROUNDED_DANGER_LARGE: 'OutlineOnHoverRoundedDangerLarge',
  ROUNDED_BLUE: 'RoundedBlue',
  ROUNDED_DARK: 'RoundedDark',
  ROUNDED_GRAY_LARGE: 'RoundedGrayLarge',
} as const;

type ButtonProps =
  | ({ variant: typeof ButtonVariants.OUTLINE_ON_HOVER_ROUNDED_DANGER_LARGE } & OutlineOnHoverRoundedDangerLargeProps)
  | ({ variant: typeof ButtonVariants.ROUNDED_BLUE } & RoundedBlueProps)
  | ({ variant: typeof ButtonVariants.ROUNDED_DARK } & RoundedDarkProps)
  | ({ variant: typeof ButtonVariants.ROUNDED_GRAY_LARGE } & RoundedGrayLargeProps);

export const Button: React.FC<ButtonProps> = React.memo((props) => {
  switch (props.variant) {
    case ButtonVariants.OUTLINE_ON_HOVER_ROUNDED_DANGER_LARGE:
      return <OutlineOnHoverRoundedDangerLarge {...props} />;
    case ButtonVariants.ROUNDED_BLUE:
      return <RoundedBlue {...props} />;
    case ButtonVariants.ROUNDED_DARK:
      return <RoundedDark {...props} />;
    case ButtonVariants.ROUNDED_GRAY_LARGE:
      return <RoundedGrayLarge {...props} />;
  }
});

Button.displayName = 'Button';
